<template>
  <Box
    :box="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-if="type === 'box'"
  />
  <Button
    :button="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'button'"
  />
  <Filler
    :filler="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'filler'"
  />
  <Icon
    :icon="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'icon'"
  />
  <Image
    :image="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'image'"
  />
  <Separator
    :separator="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'separator'"
  />
  <Span
    :span="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'span'"
  />
  <Text
    :text="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'text'"
  />
  <Video
    :video="component"
    :parentPath="parentPath"
    :selectedNode="selectedNode"
    :selectedPath="selectedPath"
    :errorPath="errorPath"
    @onSelectNode="selectNode"
    v-else-if="type === 'video'"
  />
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox, IFlexMessageBubble,
  IFlexMessageButton, IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage, IFlexMessageSeparator, IFlexMessageSpan, IFlexMessageText, IFlexMessageVideo,
} from '@/utils/types'
import Box from '@/components/common/flex-message/nodes/Box.vue'
import Button from '@/components/common/flex-message/nodes/Button.vue'
import Filler from '@/components/common/flex-message/nodes/Filler.vue'
import Icon from '@/components/common/flex-message/nodes/Icon.vue'
import Image from '@/components/common/flex-message/nodes/Image.vue'
import Separator from '@/components/common/flex-message/nodes/Separator.vue'
import Span from '@/components/common/flex-message/nodes/Span.vue'
import Text from '@/components/common/flex-message/nodes/Text.vue'
import Video from '@/components/common/flex-message/nodes/Video.vue'

@Options({
  components: { Video, Text, Span, Separator, Image, Icon, Filler, Button, Box },
  directives: { maska },
  emits: ['onSelectNode'],
})
export default class FlexMessageTreeNodes extends Vue {
  @Prop()
  component!: IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  type!: string

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  parentPath!: string

  @Prop()
  errorPath!: string[]

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
